import { Box, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import BlockContainer from '../../core/components/layout/BlockContainer';
import { Button } from '../../core/components';
import { useSelector } from 'react-redux';
import { RootState } from '../../core/store';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { useGetDashboardStatisticsQuery } from './api/billing.api';
import ApiErrorLabel from '../../core/components/ui/ApiErrorLabel';
import moment from 'moment';
const AddMindRightMoments = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();
  return (
    <Button
      startIcon={<Add />}
      onClick={() => onClick && onClick()}
      variant='contained'
      sx={{
        width: 'fit-content',
        background: theme.palette.primary[400],
        color: '#fff',
        padding: '8px 30px',
        '&:hover': {
          background: theme.palette.primary[500],
          color: '#fff',
        },
      }}
    >
      Add MindRight Moments
    </Button>
  );
};
function Billing() {
  const memberSubscription = useSelector((state: RootState) => state.memberSubscription);
  const { data, isLoading, error, isError, refetch } = useGetDashboardStatisticsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  // Current Balance = live remaining moments for both trial and non-trial (GET /students/statics → data.availableMoments, same as Homepage).
  const displayMoments = data?.data?.data?.availableMoments ?? 0;
  const momentDate = moment(memberSubscription.endDate, 'YYYY-MM-DD');
  const currentDate = moment();
  const isSubscriptionActive = momentDate.isAfter(currentDate, 'day');

  const [isApiError, setApiError] = useState(false);
  const navigation = useNavigate();
  const theme = useTheme();
  const handleChangePlan = useCallback(() => {
    navigation('/subscriptions?addOn=true');
  }, []);

  useEffect(() => {
    setApiError(isError);
  }, [isError]);

  useEffect(() => {
    (async () => {
      await refetch();
    })();
  }, []);
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: 25 }}>
      <BlockContainer>
        <Stack
          direction={'row'}
          justifyContent={'flex-start'}
          alignItems={'center'}
          gap={3}
          borderBottom={1}
          borderColor={theme.palette.divider}
          style={{
            marginLeft: -16,
            marginRight: -16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 16,
          }}
        >
          <Box
            width={35}
            height={35}
            borderRadius={2}
            bgcolor={theme.palette.primary[400]}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            💰
          </Box>
          <Typography variant='h5'>MindRight Moments Balance</Typography>
        </Stack>
        <Stack>
          <Box py={4}>
            <Typography
              mb={3}
              variant='body1'
              sx={{
                fontSize: theme.typography.fontSize.sm,
                color: theme.palette.primary[400],
              }}
            >
              Current Balance
            </Typography>
            {isLoading ? (
              <CircularProgress size='33px' style={{ margin: '20px 0px' }} />
            ) : (
              <Typography
                mb={3}
                variant='h6'
                sx={{
                  fontSize: theme.typography.pxToRem(40),
                  fontWeight: 600,
                  color: '#35B6AE',
                }}
              >
                {displayMoments}
              </Typography>
            )}

            {/* <Typography variant='body1' sx={{
                            fontSize: theme.typography.fontSizes.xs,
                            color: theme.palette.text.secondary,
                        }}>
                            Update: Today at 9:45AM
                        </Typography> */}
          </Box>
          {/* <Box>
                        <Typography mb={3} variant='body1' sx={{
                            fontSize: theme.typography.fontSizes.sm,
                            color: theme.palette.primary[400],
                        }}>
                            Current Period
                        </Typography>
                        <Typography mb={3} variant='h6' sx={{
                            fontSize: theme.typography.pxToRem(40),
                            fontWeight: 600,
                            color: theme.palette.error[400],
                        }}>42</Typography>
                        <Typography variant='body1'
                            sx={{
                                fontSize: theme.typography.fontSizes.xs,
                                color: theme.palette.text.secondary,
                            }}
                        >
                            MindRight Moments used this period
                        </Typography>
                    </Box> */}
          <Box my={3} />
          {isSubscriptionActive && <AddMindRightMoments onClick={handleChangePlan} />}
        </Stack>
        <ApiErrorLabel
          show={isApiError}
          message={error && error?.data?.message}
          dismissible
          onDismiss={() => setApiError(false)}
        />
        {/* <AutoRechargeComponent /> */}
      </BlockContainer>
    </Box>
  );
}

export default Billing;
